// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ZMdw","list":"PatternAutocomplete_list__1L_s9"};